/**
 * @todo move into service
 */
export default {
    computed: {
        listingUrl() {
            const listing = this.listing;
            const store = listing.store;

            if (store.network === 'amazon') {
                if (this.isAdminUser) {
                    return listing.url;
                }

                return listing.click_url;
            }

            return listing.go_url + '?f=1';
        },

        cartUrl() {
            //
        }
    },

    methods: {
        openListing($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const listing = this.listing;
            const store = listing.store;
            const url = this.listingUrl;
            var storage = false;

            if (store.network === 'amazon') {
                storage = true;
            }

            window.open(url, '_blank');

            window.trackProductClick(listing, url, 'product', storage); // @todo change to listing
        },

        openCart($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const url = this.cartUrl;

            // @todo trigger analytics event (add_to_cart)
        }
    }
};
